import { Component, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';
import { PartenariatService } from '../../../services/partenariat/partenariat.service';
import { SuiviComponent } from '../../../pages/suivi.component';
import { DocumentComponent } from '../../../pages/documents.component';
import { TransmettreComponent } from "../../../pages/transmettre.component";
import { CommonModule } from '@angular/common';
import { MessageComponent } from "../../../pages/messages.component";
import { DownloadService } from '../../../services/download/download.service';
import { Partenariat_Data } from '../../../interfaces/Dossier_Partenariat_Data';
import { SharedService } from '../../../services/shared/shared.service';
import { BreadcrumbComponent } from "../../../common/breadcrumb/breadcrumb.component";
import { FormatPhoneNumberPipe } from "../../../helpers/pipes/format-phone-number/format-phone-number.pipe";
import { NavigationService } from '../../../services/navigation/navigation.service';
import { verif } from '../../../helpers/decorators/verif';
import { lazyComponents } from 'app/helpers/functions/LazyComponents';
import { LazyLoadable } from 'app/interfaces/LazyLoadable';
import { Subject } from 'rxjs';


@Component({
    selector: 'app-partenariat-details',
    standalone: true,
    templateUrl: './partenariat-details.component.html',
    styleUrl: './partenariat-details.component.css',
    imports: [SuiviComponent, DocumentComponent, TransmettreComponent, CommonModule, MessageComponent, BreadcrumbComponent, FormatPhoneNumberPipe]
})
export class PartenariatDetailsComponent 
{
  @ViewChild('pagesContainer', { read: ViewContainerRef }) pagesContainer!: ViewContainerRef
  private copieMessageReady$ = new Subject<void>()

  parent:string = 'Partenariat'
  service:string = this.sharedService.getService().toString()
  title!:string
  civilite!:string
  nom!:string
  prenom!:string
  telephone!:string
  email!:string
  date_dip!:string
  date_convention!:string
  ref!:string
  idUser!:number
  idService!:number
  id_dip:number
  imgSource:string = '/assets/icons/picto-transmettreenvoi-white.png'
  liste_copie_message!:string[]

  parentData!:Partenariat_Data

  gestion_dossier:boolean
  copie_message:boolean
  gestion_convention_facturation:boolean
  saisie_donnees_abonnes:boolean

  is_dip_downloadable: boolean = false
  is_convention_downloadable: boolean = false

  readonly tabList = Object.freeze(["suivi","documents","messages","transmettre"])

  constructor
  (
    private partenariatService: PartenariatService,
    private downloadService: DownloadService,
    private sharedService: SharedService,
    private navigationService: NavigationService
  ) 
  {

    this.ref = this.sharedService.getParam("ref")?.toString() || ""
    this.id_dip = Number(this.sharedService.getParam("id_dip"))

    this.setRef()
    this.setTypeRef()
    this.setLastDip()
    this.setLastDipType()
    this.setLastDipId()

    const { gestion_dossier, copie_message, gestion_convention_facturation, saisie_donnees_abonnes } = this.sharedService.getUserRights()
    this.gestion_dossier = gestion_dossier
    this.copie_message = copie_message
    this.gestion_convention_facturation = gestion_convention_facturation
    this.saisie_donnees_abonnes = saisie_donnees_abonnes
    this.idService = this.sharedService.getIdService()
    this.idUser = this.sharedService.getIdUser()

    this.parentData = {ref:this.getRef(), id_dip:this.getIdDip(), id_service:this.idService, type:"partenariat"}
  }

  ngOnInit()
  {
    this.copieMessageReady$.subscribe(async () => {
      const currentTab = localStorage.getItem("tab") || "suivi"

      if(currentTab == "transmettre")
      {
        await this.lazyLoadComponent(currentTab)
      }
    })

    this.getDetails({ref:this.ref, id_user:this.idUser, id_dip:this.id_dip, id_service:this.idService})
    this.title = `${this.ref.replaceAll("_"," ")}`
  }

  ngAfterViewInit() 
  {
    const onglet = localStorage.getItem("tab") || "suivi"

    if( onglet )
    {
      (document.querySelector(`#${onglet}`) as HTMLButtonElement).click()
    }
  }

  getRef()
  {
    return this.sharedService.getParam("ref")?.toString() || ""
  }

  getIdDip()
  {
    return Number(this.sharedService.getParam("id_dip"))
  }

  setRef()
  {
    sessionStorage.setItem("ref", this.getRef())
  }

  setTypeRef()
  {
    sessionStorage.setItem("type_ref","partenariat")
  }

  setLastDip()
  {
    this.sharedService.setLastItem(this.getRef())
  }

  setLastDipType()
  {
    this.sharedService.setLastItemType("partenariat")
  }

  setLastDipId()
  {
    this.sharedService.setLastItemId(this.getIdDip())
  }

  //TODO @verif()
  getDetails(params:{ref:string, id_user:string|number, id_dip:number, id_service:string|number})
  {
    this.partenariatService.getDetails(params.id_service, params.id_user).subscribe(data => {
      this.civilite = data[0].civilite
      this.nom = data[0].nom
      this.prenom = data[0].prenom
      this.email = data[0].email
      this.telephone = data[0].telephone
      this.date_dip = data[0].date_partenariat?.toString()
      this.date_convention = data[0].date_convention?.toString()

      if(data[0].liste_copie_message)
      {
        this.liste_copie_message = data[0].liste_copie_message.split(",").sort()
      }

      this.is_dip_downloadable = data[0]?.dip?.is_downloadable
      this.is_convention_downloadable = data[0]?.convention?.is_downloadable
      this.copieMessageReady$.next()
    })
  }

  getIdService()
  {
    return this.sharedService.getIdService()
  }

  downloadDIP(fileName:string, id_user:number)
  {
    this.downloadService.downloadProcess({ref:'', fileName, type:'dip_convention', path:`userfiles/documents/conventions`, id_service:this.idService.toString()})
    this.sharedService.postTableConnexion(this.idUser, 434, this.idUser).subscribe()
  }

  async changeTab(tab:string)
  {
    if(this.tabList.includes(tab))
    {
      await this.lazyLoadComponent(tab)
    }
  }

  async lazyLoadComponent(tab:string)
  {
    this.pagesContainer.clear()

    const loader = lazyComponents[tab]
    if (!loader) return

    localStorage.setItem("tab", tab)

    const ComponentClass = await loader()

    const componentRef: ComponentRef<LazyLoadable> = this.pagesContainer.createComponent(ComponentClass)

    componentRef.instance.data = this.parentData

    if(tab == "transmettre")
    {
      componentRef.instance.ref = this.ref
      componentRef.instance.liste_copie_message = this.liste_copie_message
    }
  }
}
